import React, { useEffect, useState } from "react";
import { useForm,Controller } from "react-hook-form";
import Modal from "../../../components/form/Modal";
import ControllerInput from "../../../components/form/ControllerInput";
import ControllerSelect from "../../../components/form/ControllerSelect";
import DataTable from "../../../components/form/DataTable";
import FormSection from "../../../components/form/FormSection";
import AlertMessage from "../../../components/form/AlertMessage";
import { getTopics,addTopic,updateTopic,deleteTopic } from "../../../api/Api";
import { getChaptersList } from "../../../api/dropdownApi";

const TopicMaster = () => {
  const { control, handleSubmit, reset } = useForm();
  const [topics, setTopics] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState(null);
  
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const [chapters, setChapters] = useState([]);

  /** Fetch all topics */
  const fetchTopics = async () => {
    try {
      const response = await getTopics();
      const resData = response.data; // Axios response
      if (resData.success) {
        setTopics(resData.data);
      } else {
        setTopics([]);
      }
    } catch (err) {
      console.error(err);
      setTopics([]);
    }
  };

  /** Fetch all chapters */
  const fetchChapters = async () => {
    try {
      const response = await getChaptersList();
      const resData = response.data;
      if (resData.success) {
        setChapters(resData.data);
      } else {
        setChapters([]);
      }
    } catch (err) {
      console.error(err);
      setChapters([]);
    }
  };

  useEffect(() => {
    fetchTopics();
    fetchChapters();
  }, []);

  /** Add or update topic */
  const onSubmit = async (formData) => {
    try {
      if (editData) await updateTopic(editData.id, formData);
      else await addTopic(formData);
      setShowModal(false);
      reset();
      fetchTopics();
      setSuccessMessage("Topic Data Saved Successfully.");
    } catch (err) {
      console.error(err);
      setErrorMessage("Failed");
    }
  };

  /** Edit existing record */
  const handleEdit = async (row) => {
    setEditData(row);
    reset(row);
    setShowModal(true);
  };

  /** Delete topic */
  const handleDelete = async (id) => {
    if (window.confirm("Delete this topic?")) {
      try {
        await deleteTopic(id);
        fetchTopics();
      } catch (err) {
        console.error(err);
      }
    }
  };

  return (
    <div className="container mt-4">
      <div className="d-flex justify-content-between mb-3">
        <FormSection 
            title={"Topic Master"}
        />
        <button
          className="btn btn-primary"
          onClick={() => {
            setEditData(null);
            reset();
            setShowModal(true);
          }}
        >
          Add Topic
        </button>
      </div>
      
      <AlertMessage type="danger" message={errorMessage} onClose={() => setErrorMessage("")} />
      <AlertMessage type="success" message={successMessage} onClose={() => setSuccessMessage("")} />

      <DataTable
        columns={[
          { label: "Chapter", field: "chapter" },
          { label: "Topic", field: "topic" },
          { label: "Actions", field: "action" },
        ]}
        data={topics.map((ch) => ({
          chapter: <span>{ch.chapter || "-"}</span>,
          topic: <span>{ch.topic || "-"}</span>,
          action: (
            <div style={{ display: "flex", gap: "5px" }}>
              <button
                className="btn btn-sm btn-warning"
                onClick={() => handleEdit(ch)}
              >
                Edit
              </button>
              <button
                className="btn btn-sm btn-danger"
                onClick={() => handleDelete(ch.id)}
              >
                Delete
              </button>
            </div>
          ),
        }))}
      />

      <Modal
        show={showModal}
        title={editData ? "Edit Topic" : "Add Topic"}
        onClose={() => setShowModal(false)}
        classname={"modal-lg"}
        showBtn={false}
      >
        <form onSubmit={handleSubmit(onSubmit)}>
            <div className="row">
                <div className="col-md-6">
                    <Controller
                        name="chapter_id"
                        control={control}
                        defaultValue=""
                        rules={{ required: "Chapter is required" }}
                        render={({ field, fieldState }) => (
                        <ControllerSelect
                            label="Chapter"
                            options={chapters.map((c) => ({
                            label: c.chapter_name || c.name,
                            value: c.id,
                            }))}
                            {...field}
                            error={fieldState.error?.message}
                        />
                        )}
                    />
                </div>
                <div className="col-md-6">
                    <Controller
                        name="topic_name"
                        control={control}
                        defaultValue=""
                        rules={{ required: "Topic name is required" }}
                        render={({ field, fieldState }) => (
                        <ControllerInput
                            label="Topic Name"
                            {...field}
                            error={fieldState.error?.message}
                        />
                        )}
                    />
                </div>
            </div>

          <div className="mt-3 text-end">
            <button
              className="btn btn-secondary me-2"
              type="button"
              onClick={() => setShowModal(false)}
            >
              Cancel
            </button>
            <button className="btn btn-success" type="submit">
              {editData ? "Update" : "Save"}
            </button>
          </div>
        </form>
      </Modal>
    </div>
  );
};

export default TopicMaster;
